var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dfp-container"},_vm._l((_vm.zones),function(zone){return _c('div',{key:zone.domId,style:({ width: zone.unitSize[0] + 'px', height: zone.unitSize[1] + 'px' }),attrs:{"id":zone.domId}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }